import { LitElement, css, html } from 'lit';
import { property, customElement, state } from 'lit/decorators.js';
import { resolveRouterPath } from '../router';

//import bootstrap from 'bootstrap';
import { axios } from '@bundled-es-modules/axios/index.js';
import * as props from '../components/Props.js';

/*
import '../components/menu-items';
import '../js/tiny-slider.js';
import '../js/glightbox.min.js';
import '../js/rellax.min.js';
//import '../js/aos.js';
import '../js/main.js';
*/
import { format} from 'date-fns';



//import mainstyle from '../styles/shared-styles.css';
import glightbox from '../styles/glightbox.css';
import animate from '../styles/animate.css';
import flaticon from '../styles/flaticon.css';
import tinyslider from '../styles/tiny-slider.css';
import { bs } from '../styles/bootstrap.css';

import bsicon from '../styles/bootstrap-icons/bootstrap-icons.css.js';

@customElement('web-home')
export class WebHome extends LitElement {



  // For more information on using properties and state in lit
  // check out this link https://lit.dev/docs/components/properties/
  @property() message = 'Welcome!';

  static styles = [
    bs, bsicon, animate, glightbox, flaticon, tinyslider,
    css`
  `];




  @state()
  private currentHash: string = window.location.hash;

  connectedCallback() {
    super.connectedCallback();
    // Listen for changes when the component is added to the DOM
    window.addEventListener('hashchange', this.handleHashChange);
		console.log('CONNECTED CALLBACK!', window.location.hash);
		if (window.location.hash.includes('#')) {
			setTimeout( () => {
				this.doHash(window.location.hash.split('#')[1]);
			}, 1000);
		}

  }

  disconnectedCallback() {
    super.disconnectedCallback();
    // Clean up the event listener when the component is removed
    window.removeEventListener('hashchange', this.handleHashChange);
  }

  private handleHashChange = () => {
    this.currentHash = window.location.hash;
		//window.location.hash = '#newsletter';
    // Lit's reactive properties will automatically trigger a re-render
		console.log('handleHashChange', this.currentHash);
  };




  constructor() {
    super();
    this.freeGuideFlow=0;
    this.email="";
		this.ghostapi="https://thesuperlandlord.com/blog/ghost/api/"
		this.ghostkey="ce0e0d871d1dfa57cf0399b27a";
		this.posts = [];
		this.contactmessage="";
  }

  async firstUpdated() {
    // this method is a lifecycle even in lit
    // for more info check out the lit docs https://lit.dev/docs/components/lifecycle/
    console.log('This is your home page', 'props.config', props.config);
		this.loadPosts();
		console.log('this.tagName.toLowerCase()', this.tagName.toLowerCase(), 'window.location', window.location, 'window.history.pushState', window.history.state);
		/*
		if (window.location.hash.includes('#')) {
			this.doHash(window.location.hash.split('#')[1]);
		}
		*/

  }

  share() {
    if ((navigator as any).share) {
      (navigator as any).share({
        title: 'PWABuilder pwa-starter',
        text: 'Check out the PWABuilder pwa-starter!',
        url: 'https://github.com/pwa-builder/pwa-starter',
      });
    }
  }

  getFree() {
    console.log('GET FREE!');
		let options = {baseURL: props.getServer('srv')};
        //const freeGuideModal = new bootstrap.Modal(this.shadowRoot.getElementById('freeGuideModal'), options)
    //freeGuideModal.show();
    let eEmail = this.shadowRoot.getElementById("email");
		let eEmail2 = this.shadowRoot.getElementById("email_newsletter");
		if (eEmail.value) {
	    this.email = eEmail.value;
		} else {
			this.email = eEmail2.value;
		}


    let subscribeobj={Email:this.email,Source:'website 7mistakes',Action:'7mistakes',Type:'newsletter'}
    axios.put("/subscribe", subscribeobj, options).then((wire) => {
      var resp = wire.data;
      console.log('/srv/subscribe/ resp', resp, 'put', subscribeobj);
      this.requestUpdate();
    }).catch(function (error) {
      console.error(error, "code: " + error.status);
      //props.goError();
    });

    this.freeGuideFlow=2;
    this.requestUpdate('freeGuideFlow');




  }

  showFree() {
    //let divFreeGuide = this.shadowRoot.getElementById('freeGuideDiv');
    this.freeGuideFlow=1;
    this.requestUpdate('freeGuideFlow');
  }

	loadPosts() {
		//http://thesuperlandlord.penglai:2368/blog/ghost/api/content/posts/?key=edf4101465effc11ccf54f27c7
		let urlposts = this.ghostapi+"/content/posts?key="+this.ghostkey
		console.log("load posts urlposts=", urlposts);
    axios.get(urlposts, {}).then((wire) => {
      var resp = wire.data;
      console.log(urlposts,' resp=', resp);
			let posts = resp.posts;
			this.posts = posts;
      this.requestUpdate('posts');
    }).catch(function (error) {
      console.error(error, "code: " + error.status);
      //props.goError();
    });


	}

	doMenuClick(e) {
    let href = e.currentTarget.dataset.href;
		console.log('doMenuClick', href);
		if (href.startsWith('http')) {
			e.preventDefault();
			window.location.href=href;
		} else if (href.includes('#')) {
			e.preventDefault();
			let hashid = href.split('#')[1];

			console.log('ANCHOR!', href, hashid);
			window.location.hash = 'newsletter';
			this.doHash(hashid);

		}

	}
	doHash(hashid) {
		const targetElement = this.shadowRoot.getElementById(hashid);
		console.log('doHash', hashid, targetElement)
		if (targetElement) {
    	targetElement.scrollIntoView({
      behavior: 'smooth' // For smooth scrolling
    	});
		}
	}

	goContact() {
		console.log('gocontact', props.getServer("srv/contactus/"));
    let eEmail = this.shadowRoot.getElementById("email_contact");
		let eFullname = this.shadowRoot.getElementById("fullname");
		let eMessage = this.shadowRoot.getElementById("message");

    //let options = {baseURL: 'https://thesuperlandlord.com/srv'};
		let options = {baseURL: props.getServer('srv')};
    let messageobj={Email:eEmail.value,Name:eFullname.value,Message:eMessage.value};

    axios.put("/contactus", messageobj, options).then((wire) => {
      var resp = wire.data;
      console.log('/srv/contact/ resp', resp, 'put', messageobj);
			this.contactmessage = '<b>All set!</b><br/>Thanks for reaching out—we’ve received your message and will be in touch soon. Until then, grab a coffee ☕ or check out our latest posts.';
      this.requestUpdate();
    }).catch(function (error) {
      console.error(error, "code: " + error.status);
      //props.goError();
    });


	}

  render() {
    return html`
      <!--app-header></app-header-->

      <!--main-->



	<nav class="navbar-expand-lg  ftco-navbar-light" > <!-- navbar -->
		<div class="container-xl">
			<a class="navbar-brand" href="index.html">
				<img src="/assets/images/thesuperlandlord_logo_darkbg.png" style="width:250px;">
			</a>
			<button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
				<span class="fa fa-bars"></span> Menu
			</button>
			<div class="collapse navbar-collapse" id="navbarSupportedContent" style="margin-top:-40px;">
				<ul class="navbar-nav ms-auto mb-2 mb-lg-0">
					${props.config.menuItems.map((menuitem)=>{
						let path = this.tagName.toLowerCase();
						console.log('path', path, 'window.location.hash', window.location.hash, 'menuitem', menuitem.href)
						if (menuitem.hash) {
							return html`
								<li class="nav-item"><a class="nav-link" href="#"
									@click="${this.doMenuClick}" data-href="${menuitem.href}"
								>${menuitem.name}</a></li>
								`
						} else {
							return html`
								<li class="nav-item"><a class="nav-link" href="${menuitem.href}"
								>${menuitem.name}</a></li>
							`

						}

					})}
					<!--
					<li class="nav-item"><a class="nav-link active" href="index.html">Home</a></li>
					<li class="nav-item"><a class="nav-link" href="#aboutus">About us</a></li>
					<li class="nav-item"><a class="nav-link" href="http://www.thesuperlandlord.jeju/blog/">Blog</a></li>
					<li class="nav-item"><a class="nav-link" href="/videopodcasts">Video Podcast</a></li>
					<li class="nav-item"><a class="nav-link" href="#newsletter">Newsletter</a></li>
					<li class="nav-item"><a class="nav-link" href="#contact">Contact us</a></li>
					-->
				</ul>

			</div>
		</div>
	</nav>

	<section class="hero-wrap">
		<div class="overlay"></div>
		<div class="container">
			<div class="row no-gutters slider-text align-items-center justify-content-between align-items-stretch">
				<div class="col-md-8 col-lg-7 text d-flex align-items-center">
					<div>
						<h1 >The Book That’s Changing How Landlords Build Wealth</h1>

						<p class="mt-5 mb-5" style="color:#FFF;">
							It’s time to stop waiting for “passive” income and start earning active profits.
							Discover how to think, act, and win like a hands-on real estate investor.
						</p>

						<p class="d-flex">
							<!-- style="background-color: #18609b;" -->
							<a href="https://www.amazon.com/Super-Landlord-Estate-Hands-Landlords-ebook/dp/B0GCYNWXPG/ref=sr_1_1?sr=8-1" class="btn btn-primary d-flex align-items-center" ><span>Order The Book</span></a>
						</p>

						<ul class="ftco-social">
							<li><a href="#"><span class="fa fa-twitter"></span></a></li>
							<li><a href="#"><span class="fa fa-facebook"></span></a></li>
							<li><a href="#"><span class="fa fa-instagram"></span></a></li>
							<li><a href="#"><span class="fa fa-google-plus"></span></a></li>
						</ul>
					</div>
				</div>
				<div class="col-md-4 col-lg-5 svg d-flex align-items-center" >
					<img src="/assets/images/book_cover_3d.png" class="img-fluid" alt=" " style="margin-left:20px;margin-top:20px;">
				</div>

		<!--
		<div style="background-color:#fff3cd;color:#000;">
			<p>Hello Goodreads! - I am the author of "The Super Landlord".
				I am currently applying to become an author on goodreads under my account email: matt@thesuperlandlord.com.
				The kdp email account which I published the book under is kdp@azureturtlepress.com.
				I hope this verifies that I am the author of this book.  Please approve my author application.
				</p>
		</div>
		-->

			</div>
		</div>
	</section>
















	<section class="ftco-section ftco-about-section ftco-no-pt ftco-no-pb bg-light" >
		<div class="container-xl" >
			<div class="row g-xl-5" >
				<div class="col-md-6 d-flex align-items-center" data-aos="fade-up" data-aos-delay="100" data-aos-duration="1000">
          <img src="/assets/images/manpuzzle.svg" alt="Image" class="img-fluid">
				</div>
				<div class="col-md-6 py-5 heading-section" data-aos="fade-up" data-aos-delay="200" data-aos-duration="1000" >
					<div class="py-md-5" >
						<span class="subheading">Free Guide</span>
            <h2 class="text-black" style="margin-top:0px;">
              New to Landlording? Don’t Make These 7 Costly Mistakes.
            </h2>
            <p class="mb-4">
              Most landlords lose thousands their first year — not from bad luck, but from bad habits.
              Learn what they are (and how to avoid them) before they drain your profits.
            </p>

            <p class="mb-4">
              Get my free guide, The 7 Biggest Mistakes New Landlords Make (And How to Avoid Them),
              and discover how to:
              <ul>
                <li>Avoid the traps that cost new landlords the most money</li>
                <li>Find better tenants faster</li>
                <li>Manage smarter and renovate for real returns</li>
                <li>Build lasting wealth through hands-on real estate investing</li>
              </ul>
            </p>
            <div>
              <a href="javascript:void(0)" class="btn btn-primary mr-2 mb-2 ${(this.freeGuideFlow==0)?'d-block':'d-none'} "
                @click="${this.showFree}">Send Me the Free Guide</a>
            </div>

            <div id="freeGuideDiv" class="author-box ${(this.freeGuideFlow>0)?'d-block':'d-none'}">

              <!-- ============== freeGuideFlow 1 ================== -->


              <div class="${(this.freeGuideFlow==1)?'d-block':'d-none'}">
                <p>
                  Get your free guide instantly — plus weekly insights from The Super Landlord Newsletter,
                  full of real-world insights, templates, and tools that help you build wealth the hands-on way.
                </p>
                <div class="form-floating mb-3 input-group" style="border:solid 1px #CCC;">
                  <input type="email" style="width:200px;" class="form-control" id="email" placeholder="name@example.com">
                  <label for="email" style="font-family:Roboto;">Email</label>
                </div>
                  <a href="javascript:void(0)" class="btn btn-primary mr-2 mb-2"
                    @click="${this.getFree}">
                      Send Me the Free Guide
                  </a>
              </div>

              <!-- ============== freeGuideFlow 2 ================== -->
              <div class="${(this.freeGuideFlow==2)?'d-block':'d-none'}">
                <h3>
                  <img src="/assets/icons/big_green_check.png" style="height:48px;"/> You’re In! Your Free Guide Is on Its Way.
                </h3>
                <div >
                  <p>
                    Check your <b>${this.email}</b> inbox for The 7 Biggest Mistakes New Landlords Make (And How to Avoid Them).
                    You’ve also been added to The Super Landlord Newsletter, where I share weekly insights, templates, and tips to help you:
                    <ul>
                      <li>Maximize your rental profits</li>
                      <li>Improve tenant quality</li>
                      <li>Build long-term wealth as a hands-on investor</li>
                    </ul>
                    If you don’t see the email in a few minutes, check your promotions or spam folder.

                  </p>
                </div>
              </div>



            </div> <!-- freeGuideDiv -->
					</div>
				</div>
			</div>
		</div>
	</section>


























<!--
====== Companion Workbook =======
-->

<!--
	<section class="ftco-section" id="workbook">
		<div class="container-xl">
			<div class="row justify-content-center pb-5">
				<div class="col-md-8 text-center heading-section" data-aos="fade-up" data-aos-duration="1000">
					<span class="subheading">Companion Workbook</span>
					<h2 class="mb-3">The Super Landlord Companion Workbook</h2>
				</div>

				<div class="row py-5">
					<div class="col-6">
						<h3>The Tools to Build Real Estate Wealth—Right in Your Hands</h3>
						<p>
						This companion workbook transforms the lessons from The Super Landlord into a practical, repeatable system.
						</p>
						<p>
						You’ll find exercises, prompts, tracking sheets, and implementation guides to help you create stronger cash flow, better tenants, and higher-performing rentals.
						</p>
						<p>
						<b>Because wealth grows when you take action.</b>
						</p>
						<p>
							<a href="javascript:void(0)" class="btn btn-primary mr-2 mb-2"
								@click="">
									Coming Soon!
							</a>
						</p>
					</div>
					<div class="col-6">
						<img src="/assets/images/companion_workbook_cover3.png" style="height:500px;">
					</div>
				</div>

				</div>
			</div>
	</section>

-->


























<!--
====== Newsletter =======
-->

	<section class="img v-section ftco-section bg-light" id="newsletter">
		<div class="overlay" style="height:400px;"></div>
		<div class="container-xl">
			<div class="row justify-content-center">
				<div class="col-md-8 heading-section heading-section-white text-center mb-1" data-aos="fade-up" data-aos-duration="1000">
					<span class="subheading">Newsletter</span>
					<h2 class="mb-1" style="margin-top:0px;">Supercharge Your Landlord Success</h2>
					<p>
						Sign up for exclusive content and updates from The Super Landlord—delivered straight to your inbox.
					</p>
					<div class="row">
						<div class="col-9">
							<div class="form-floating mb-3 input-group" style="border:solid 1px #CCC;">
								<input type="email" style="width:200px;" class="form-control" id="email_newsletter" placeholder="name@example.com">
								<label for="email" style="font-family:Roboto;">Email</label>
							</div>
						</div>
						<div class="col-3">
							<a href="javascript:void(0)" class="btn btn-primary mr-2 mb-2"
								@click="${this.getFree}">
									Sign Up
							</a>
						</div>
					</div>

				</div>
			</div>
	</section>














<!--
====== Courses =======
-->
<!--
	<section class="ftco-section" id="courses">
		<div class="container">
			<div class="row justify-content-center pb-5">
				<div class="col-md-7 text-center heading-section" data-aos="fade-up" data-aos-duration="1000">
					<span class="subheading">Courses</span>
					<h2 class="mb-3">Courses for Hands-On, High-ROI Landlords</h2>
					<div class="row">
					<div class="col-12">
						<a href="javascript:void(0)" class="btn btn-primary mr-2 mb-2"
								@click="">
									Coming Soon!
						</a>
					</div>
					</div>

				</div>
			</div>

		</div>
	</section>
-->



						<section class="ftco-section bg-light" style="border-bottom: 2px solid #666;" id="contact">
							<div class="container-xl">
								<div class="row justify-content-center mb-5">
									<div class="col-md-7 heading-section text-center" data-aos="fade-up" data-aos-duration="1000">
										<span class="subheading">Contact</span>
										<h2 style="margin-top:0px;margin-bottom:1px;">
											Contact Us
										</h2>
										<p style="margin-top:10px;">
											Have a landlording problem you’re trying to solve?
										</p>
										<p style="margin-top:10px;">
											matt at thesuperlandlord dot com.  Published by Azure Turtle Press (kdp at azureturtlepress dot com)
										</p>
										<p class="${(this.contactmessage) ? "d-block" : "d-none"}" style="margin-top:10px;background-color:#a3cfba;border:dotted 4px #198754;color:#111;;padding:10px;">
											${this.contactmessage}
										</p>
									</div>
								</div>


								<div class="row">
									<div class="col-1"></div>
									<div class="col-9">
										<div class="form-floating mb-3 input-group" style="border:solid 1px #CCC;">
											<input type="text" style="width:200px;" class="form-control" id="fullname" placeholder="John Landy">
											<label for="fullname" style="font-family:Roboto;">Name</label>
										</div>
									</div>
								</div>

								<div class="row">
									<div class="col-1"></div>
									<div class="col-9">
										<div class="form-floating mb-3 input-group" style="border:solid 1px #CCC">
											<input type="email" style="width:200px;" class="form-control" id="email_contact" placeholder="name@example.com">
											<label for="email_contact" style="font-family:Roboto;">Email</label>
										</div>
									</div>
								</div>

								<div class="row">
									<div class="col-1"></div>
									<div class="col-9">
										<div class="form-floating mb-3 input-group" style="border:solid 1px #CCC;">
											<textarea type="text" style="width:200px;" class="form-control" id="message" placeholder="Message Here"></textarea>
											<label for="message" style="font-family:Roboto;">Message</label>
										</div>
									</div>
								</div>

								<div class="row">
									<div class="col-1"></div>
									<div class="col-9">
										<a href="javascript:void(0)" class="btn btn-primary mr-2 mb-2"
											@click="${this.goContact}">
												Send
										</a>
									</div>
								</div>


							</div>
						</section>








						<section class="ftco-section bg-light">
							<div class="container-xl">
								<div class="row justify-content-center mb-5">
									<div class="col-md-7 heading-section text-center" data-aos="fade-up" data-aos-duration="1000">
										<span class="subheading">Our Blog</span>
										<h2 style="margin-top:0px;margin-bottom:1px;">
											The Super Landlord Clinic

											<!--The Super Landlord Blog-->
										</h2>
										<p style="margin-top:10px;">
											Real fixes for real landlord problems.

											<!--New Rules, Real Strategies, and Real Wealth for Real Landlords-->
										</p>
									</div>
								</div>


								<div class="row">

${this.posts.map((post)=>{
	post.url = post.url.replace('http:', 'https://');
	post.feature_image = post.feature_image.replace('http:', 'https:');
	return html`
		<div class="col-md-6 col-lg-3 d-flex">
			<div class="blog-entry justify-content-end" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="100">
				<a href="${post.url}" class="block-20 img d-flex align-items-end" style="background-image: url('${post.feature_image}');">
				</a>
				<div class="text">
					<h3 class="heading mb-3"><a href="${post.url}">${post.title}</a></h3>
					<p class="meta"><span>${format(new Date(post.updated_at), "MMM, dd yyyy")}</span>by Matthew Ma</p>
				</div>
			</div>
		</div>
	`
})}




								</div> <!-- row -->

							</div>
						</section>








</html>



















      <!--/main-->
    `;
  }
}
